import { request } from "../util/Request";

export async function getAllEvents() {
  const response = await request("/api/Event/GetAll");
  console.log(response);
  return await response.json();
}
